import React, { createContext, useContext, useEffect, useState } from "react";
import BuyPlan from "../pages/plan/BuyPlan";
import { subscriptionCheck } from "../Services/paymentService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const PaymentStatusContext = createContext();

export const PaymentStatusProvider = ({ children }) => {
  const [isActivePlan, setIsActivePlan] = useState(true);
  const [planDetails, setPlanDetails] = useState({});
  const userData = useSelector((state) => state.user.user);
  const adminData = useSelector((state) => state.user);
  const adminAccessToken = localStorage.getItem("admin_accessToken");
  const adminRefreshToken = localStorage.getItem("admin_refreahToken");

  const adminRole = userData?.role?.find(
    (item) =>
      item?.code === "COMPANY-ADMINISTRATOR" || item?.code === "COMPANY-MANAGER"
  );

  const superAdminRole = userData?.role?.find((item) => item?.code === "ADMIN");

  const handleSubscriptionChecking = async () => {
    try {
      const res = await subscriptionCheck({});
      if (res?.status === 200) {
        if (res?.data && res?.data?.trans_details) {
          setPlanDetails(res?.data?.trans_details);
          if (
            res?.data?.trans_details?.status === 1 ||
            res?.data?.trans_details?.status === 2
          ) {
            setIsActivePlan(true);
          } else {
            setIsActivePlan(false);
          }
        } else {
          setIsActivePlan(false);
          setPlanDetails({});
        }
      } else {
        setIsActivePlan(false);
        setPlanDetails({});
      }
    } catch (err) {
      setIsActivePlan(false);
      setPlanDetails({});
    }
  };

  useEffect(() => {
    if (
      (!adminAccessToken || !adminRefreshToken) &&
      (adminRole?.code === "COMPANY-ADMINISTRATOR" ||
        adminRole?.code === "COMPANY-MANAGER")
    ) {
      handleSubscriptionChecking();
    } else if (superAdminRole?.code === "ADMIN") {
      setIsActivePlan(true);
    } else {
      setIsActivePlan(true);
    }
  }, [adminRole, adminAccessToken, adminRefreshToken, superAdminRole]);

  return (
    <PaymentStatusContext.Provider value={{ isActivePlan, setIsActivePlan }}>
      {/* {superAdminRole?.code === "ADMIN" ? (
        children
      ) : (
        // ) : (!adminAccessToken || !adminRefreshToken) &&
        //   (adminRole?.code === "COMPANY-ADMINISTRATOR" ||
        //     adminRole?.code === "COMPANY-MANAGER") &&
        //   isActivePlan &&
        //   planDetails &&
        //   planDetails?.status === 1 ? (
        //   children
        <BuyPlan />
      )} */}
      {isActivePlan ? children : <BuyPlan />}
    </PaymentStatusContext.Provider>
  );
};

export const usePaymentStatus = () => {
  return useContext(PaymentStatusContext);
};
